"use client";

import { ChevronRight } from "lucide-react";
import React from "react";
import Typography from "@/components/shared/Typography";
import Button from "@/components/ui/Button";
import Drawer from "@/components/ui/Drawer";
import { URLS } from "@/lib/consts";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { BaseSlide } from "../types";
import { INDUSTRIES_SLIDE_INDEX } from "./industries-slide";
import { SERVICES_SLIDE_INDEX } from "./services-slide";
import Slide from "./slide";

function RootSlide({ index = 0, goToSlide, className, ...props }: BaseSlide) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Slide index={index} className={cn(className, classes)} {...native}>
      <Button
        variant="ghost"
        className="w-full flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
        onClick={() => goToSlide(SERVICES_SLIDE_INDEX)}
        aria-label="Go to Service Categories Navigation Menu"
      >
        <Typography.Small className="text-left text-sm leading-none font-medium w-full">
          Services
        </Typography.Small>
        <ChevronRight />
      </Button>

      <Button
        variant="ghost"
        className="w-full flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
        onClick={() => goToSlide(INDUSTRIES_SLIDE_INDEX)}
        aria-label="Go to Industries Navigation Menu"
      >
        <Typography.Small className="text-left text-sm leading-none font-medium w-full">
          Industries
        </Typography.Small>
        <ChevronRight />
      </Button>

      <Drawer.Close asChild>
        <Button.Link
          href={URLS.ABOUT}
          variant="ghost"
          className="w-full flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
          aria-label="Go to the About Page"
        >
          <Typography.Small className="text-left text-sm leading-none font-medium w-full">
            About
          </Typography.Small>
          <ChevronRight />
        </Button.Link>
      </Drawer.Close>

      <Drawer.Close asChild>
        <Button.Link
          href={URLS.CONTACT_US}
          variant="ghost"
          className="w-full flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
          aria-label="Go to the Contact Us Page"
        >
          <Typography.Small className="text-left text-sm leading-none font-medium w-full">
            Contact Us
          </Typography.Small>
          <ChevronRight />
        </Button.Link>
      </Drawer.Close>
    </Slide>
  );
}

export default RootSlide;
